import * as React from 'react';

var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgRedWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E72F3D",
    d: "M12 2.5l11 19H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.574 16l.176-6h-1.5l.176 6h1.148zM12 18.5c.406 0 .75-.333.75-.75A.754.754 0 0012 17a.754.754 0 00-.75.75c0 .417.344.75.75.75z",
    fill: "#FFF"
  }))));
}

export { SvgRedWarningTriangle as S };
